import { Button as MantineButton, MantineSpacing } from '@mantine/core';
import { ReactNode } from 'react';
import buttonClasses from './Button.module.css';
import { NavLink } from 'react-router-dom';

type NavLinkProps =
  | { to?: undefined; target?: never }
  | {
      to: string;
      target?: '_blank' | '_self' | '_parent' | '_top';
    };

type BaseButtonProps = {
  size?: 'xl' | 'lg' | 'md' | 'sm' | 'xs';
  children?: ReactNode | string;
  type?: 'submit' | 'reset' | 'button' | undefined;
  name?: string;
  disabled?: boolean;
  loading?: boolean;
  onClick?: () => unknown | Promise<unknown>;
  fullWidth?: boolean;
  px?: MantineSpacing;
  variant?: 'primary' | 'secondary';
  value?: string;
  className?: string;
  leftSection?: React.ReactNode;
} & NavLinkProps;

type ButtonProps = BaseButtonProps;

export default function Button({
  variant = 'primary',
  size = 'md',
  children,
  type,
  name,
  disabled,
  loading,
  onClick,
  px,
  fullWidth,
  to,
  target,
  value,
  className,
  leftSection,
}: ButtonProps) {
  const variantMap = {
    primary: 'primary-new',
    secondary: 'secondary',
  };

  const buttonBaseProps = {
    className: className ? className : buttonClasses.button,
    variant: variantMap[variant],
    size: size,
    type: type,
    disabled: disabled,
    loading: loading,
    onClick: onClick,
    px: px,
    fullWidth: fullWidth,
    value,
    leftSection,
  };

  if (to) {
    return (
      <MantineButton {...buttonBaseProps} to={to} target={target} component={NavLink}>
        {children}
      </MantineButton>
    );
  }

  return (
    <MantineButton {...buttonBaseProps} name={name}>
      {children}
    </MantineButton>
  );
}
